import { CSS_REGISTRY_DEFAULT } from './constants';
// TODO(koop): Can we make this agnostic from any css system?
//   e.g. Could we plug Emotion or Stitches into this?
const cssRegistry = {};
export function registerCss(id, css) {
    cssRegistry[id] = css;
}
export function getRegisteredCss(id) {
    return cssRegistry[id == null ? CSS_REGISTRY_DEFAULT : id];
}

//# sourceMappingURL=registry.js.map